import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import NewWorkspaceAndUsersMetricsLayout from '../../../features/analytics/components/BusinessMetrics/NewWorkspaceAndUsersMetricsLayout';
import PaidButNotOnboardedCustomers from '../../../features/analytics/components/BusinessMetrics/PaidButNotOnboardedCustomers';
import WorkspaceActivityMetricsLayout from '../../../features/analytics/components/BusinessMetrics/WorkspaceActiivtyMetricsLayout';
import WorkspacePlanMetrics from '../../../features/analytics/components/BusinessMetrics/WorkspacePlanMetrics';
import CVParserAnalytics from '../../../features/analytics/cvParser/CVParserAnalytics';
import CVUploadAnalytics from '../../../features/analytics/cvupload/CVUploadAnalytics';
import DemergeCandidates from '../../../features/candidates/components/DemergeCandidates/DemergeCandidates';
import { PrismExtensionPage } from '../../../features/prismSettingsPage/prismExtension';
import { PrivateExtensionPage } from '../../../features/privateExtensionPage/privateExtension';
import UsersPageAdmin from '../../../features/users/UsersPageAdmin';
import PaidButNotOnboardedCustomersForm from '../../analytics/components/BusinessMetrics/PaidButNotOnboardedCustomersForm';
import InternalMISAcrossWorkspaces from '../../analytics/InternalMISAnalytics/InternalMISAcrossWorkspaces';
import InternalMISWorkspaceLevel from '../../analytics/InternalMISAnalytics/InternalMISWorkspaceLevel';
import WorkspaceDetails from '../../workspacesListing/components/workspaceDetails/WorkspaceDetails';
import WorkspacesListing from '../../workspacesListing/components/WorkspacesListing';

import AdminHome from './AdminHome';

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminHome />} />
      <Route path="/*" element={<AdminHome />} />
      <Route path="/workspace/listing" element={<WorkspacesListing />} />
      <Route path="/workspace/:workspaceId/edit" element={<WorkspaceDetails />} />
      <Route path="/business-metrics/workspace-plan" element={<WorkspacePlanMetrics />} />
      <Route
        path="/business-metrics/workspace-activity"
        element={<WorkspaceActivityMetricsLayout />}
      />
      <Route
        path="/business-metrics/workspace-added"
        element={<NewWorkspaceAndUsersMetricsLayout />}
      />
      <Route
        path="/business-metrics/onbording-details/save"
        element={<PaidButNotOnboardedCustomersForm />}
      />
      <Route
        path="/business-metrics/onbording-details/get"
        element={<PaidButNotOnboardedCustomers />}
      />
      <Route
        path="/cv-upload"
        element={
          <RouteWithTitle title="CV Upload - Wisestep">
            <CVUploadAnalytics />
          </RouteWithTitle>
        }
      />
      <Route
        path="/cv-parser-status"
        element={
          <RouteWithTitle title="CV Parser - Wisestep">
            <CVParserAnalytics />
          </RouteWithTitle>
        }
      />
      <Route
        path="/user-management"
        element={
          <RouteWithTitle title="Disable Users-Admin">
            <UsersPageAdmin />
          </RouteWithTitle>
        }
      />
      <Route
        path="/internal-mis"
        element={
          <RouteWithTitle title="Internal MIS Analytics">
            <InternalMISAcrossWorkspaces />
          </RouteWithTitle>
        }
      />
      <Route path="/candidates/demerge-candidates" element={<DemergeCandidates />} />
      <Route
        path="/internal-mis-workspace-level"
        element={
          <RouteWithTitle title="Internal MIS Analytics">
            <InternalMISWorkspaceLevel />
          </RouteWithTitle>
        }
      />
      <Route
        path="/extensions/prism-extension"
        element={
          <RouteWithTitle title="Prism Extension">
            <PrismExtensionPage />
          </RouteWithTitle>
        }
      />
      <Route
        path="/extensions/private-extension"
        element={
          <RouteWithTitle title="Private Extension">
            <PrivateExtensionPage />
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
